import React from 'react'; 
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { BaseComponent } from '../../../BaseComponent';
import { getSirvImgUrlExterior } from '../../../../modules/Vehicles/helpers';
import { selectWorks } from '../../../../modules/Api/selectors';
import {
  REQUEST_VEHICLE_DOCUMENTS_BY_TYPE,
  REQUEST_VEHICLES_DOCUMENTS_BY_TYPE,
} from '../../../../modules/Vehicles/constants';
import { getDocumentsByType } from '../../../../modules/Vehicles/actions';
import { Loader } from '../../../Loader';
import cn from 'classnames';
import { selectVehicleDocs } from '../../../../modules/Vehicles/selectors';

const Container = styled.div`
  min-width: 150px;
  max-width: 350px;
  min-height: 50px;
  margin: 6px;

  .avatarImg {
    max-width: 100%;
    height: auto;
    overflow: hidden;
  }  

  @media (max-width: 768px) {
    width: 300px;
    height: 160px;
  }
  @media (max-width: 450px) {
    // width: 150px;
    height: 80px;
  }

  position: relative;

 .img-infocard {
    background-size: cover;
    background-repeat: no-repeat; 
    background-position: center center;
    max-width: 100%;
    height: 240px;
    margin-top: -10px;
    clip-path: inset(15px 0 0 0);
    margin-bottom: 20px;
  }

  //  .img-infocard {
  //   background-size: cover;
  //   background-repeat: no-repeat; 
  //   background-position: center center;
  //   max-width: 100%;
  //   height: 250px;
  //   margin-top: -10px;
  //   clip-path: inset(15px 0 0 0);
  //   margin-bottom: 20px;
  // }


             

  .img {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    margin-top: 0px;
    margin-right: 10px;
    // clip-path: inset(15px 0 0 0);
    height: 90px;
  }
`;

const STATE = {};

class VehicleAvatarComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.autoLoadPhotos) {
      this.props.getPhotos(result => {
        if (result?.length && result[0]?.id) {
          this.setState({ leftFrontImage: result[0] });
        }
      });
    }
  }

  render() {
    const { props } = this;
    let avatarStyle = '';
    if (this.props.location1 == "infoCard") {
      avatarStyle = 'img-infocard';
    } else {
      avatarStyle = 'img';
    }
    console.log (this.props.photos + 'photo?');
    if (this.props.work || (!this.props.photos && !this.props.autoLoadPhotos)) return <Loader small />;
    
    const leftFrontImage = this.state.leftFrontImage || this.props.photos?.[0];
    console.log (leftFrontImage + 'leftFrontImage');
    if (leftFrontImage?.id) {
      return (
        <>
          <Container className={cn('avatar', props.className)} vehicle={props.vehicle} onClick={props.onClick}>
            <div
              className={cn(avatarStyle, props.className)}
              style={{
                backgroundImage: `${`url(${leftFrontImage?.url})`}`,
               // height: "90px",
              }}
            ></div>
          </Container>
        </>
      );
    }
    return (
      <>
        <Container className={cn('avatar', props.className)} vehicle={props.vehicle} onClick={props.onClick}>
          <div
            
            className={cn(avatarStyle, 'bottom', props.className)}
            style={{
              backgroundImage: `url('/public/images/placeholder.png')`,
            }}
          ></div>
        </Container>
      </>
    );
  }
}

VehicleAvatarComp.propTypes = {
  autoLoadPhotos: PropTypes.bool,
};
VehicleAvatarComp.defaultProps = {
  autoLoadPhotos: true,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_VEHICLE_DOCUMENTS_BY_TYPE}-${ownProps.vehicle?.id}`]),
    photos: selectVehicleDocs(ownProps.vehicle?.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    getPhotos(callback) {
      dispatch(getDocumentsByType(ownProps.vehicle?.id, 'photo_interior_import_0impression_left_front', callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleAvatar = compose(withConnect, withRouter)(VehicleAvatarComp);
